<script>
import Stars from "./Stars";

import newOrderHelper from "@/utils/helpers/newOrder";

export default {
  props: {
    professional: {
      type: Object,
      required: true
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Stars
  },
  methods: {
    canApplyDiscount() {
      if (this.$route.name === "cycle-checkout") return;
      return newOrderHelper.canApplyDiscount(this.professional.id);
    }
  },
  filters: {
    fullName(account) {
      return (
        account.first_name.trim().split(" ")[0] +
        " " +
        account.last_name.trim().split(" ")[
          account.last_name.trim().split(" ").length - 1
        ]
      );
    },
    firstName(account) {
      return account.first_name.split(" ")[0];
    },
    completedOrdersCount(num) {
      return num < 5 ? "< 5" : num;
    }
  }
};
</script>

<template>
  <section
    class="professional"
    :class="{'pointer': selectable, 'checked': checked}"
    
  >
    <div class="label" :class="{transparent: !canApplyDiscount()}">10% desconto</div>
    <img :src="professional.account.profile.profile_picture" />
    <div v-if="selectable" class="hovered" @click.stop="$emit('showfeedbacks',professional)">
      <div v-if="checked" class="icon-check"></div>
    </div>
    <p class="professional-full-name">{{professional.account | fullName}}</p>
    <small>{{professional.completed_orders_count | completedOrdersCount}} limpezas</small>

    <stars :rating="professional.rating" />

    <slot></slot>

    <button class="btn-professional bg-purple" v-bind:class="{ 'bg-ease-pink': checked}" @click="$emit('selected', professional)"> 
      <span v-if="checked">agendar com {{professional.account | firstName}}</span>
      <span v-else>escolher {{professional.account | firstName}}</span>
      
    </button> 

  </section>
</template>

<style scoped>
.label {
  background-color: #000;
  color: #fff;
  transform: translateY(130px);
  font-weight: 600;
  z-index: 999;
}

.label.transparent {
  opacity: 0;
}

section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  user-select: none;
}

.professional {
  padding: 10px 20px;
  border-radius: 4px;
}

p {
  font-size: 15px;
  margin: 10px 0 5px 0;
}

.professional-full-name {
  font-size: 15px;
  margin: 10px 0 5px 0;
  height: 40px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

small {
  font-weight: bold;
  color: var(--purple);
  font-size: 12px;
}

img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 4px solid #f1f1f1f1;
  border-radius: 100%;
}

.btn-professional {
  font-family: "Roboto", sans-serif;
  padding: 12px 5px;
  border-radius: 4px;
  border: none;
  outline: none;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  cursor: pointer;
  font-size: 14px;
  width: calc(100% + 45px);
  text-transform: uppercase;
  margin: 15px;
}

.btn-professional:hover {
  background-color: #af006b !important;
  transition: all 0.25s ease;
}

.bg-ease-pink {
  background-color: #af006b !important;
  transition: all 0.25s ease;
}

.hovered {
  opacity: 0;
  width: 120px;
  height: 120px;
  margin-top: -124px;
  border-radius: 100%;
  background: linear-gradient(
    45deg,
    rgba(204, 204, 204, 0.8) 0%,
    rgba(204, 204, 204, 0.3) 100%
  );
  z-index: 99;
  transition: all 0.25s ease;
}

.hovered .icon-check {
  background: url("/static/icon-check.svg") no-repeat center;
  background-size: 25px;
  width: 100%;
  height: 100%;
}

.checked .hovered {
  opacity: 1;
  background: linear-gradient(
    45deg,
    rgba(96, 50, 133, 0.8) 0%,
    rgba(175, 0, 107, 0.8) 100%
  );
}

section:hover .hovered {
  opacity: 1;
}

@media (min-width: 768px) {
  section {
    margin: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Card.vue